<template>
  <div class="d-flex" style="width: 100%">
    <div 
      class="d-flex justify-center rounded-lg py-2 px-2 elevation-6"
      :style="{ 'background-color': iconColor }"
    >
      <v-icon color="white">mdi-note-search-outline</v-icon>
    </div>

    <div class="d-flex flex-column flex-grow-1 ml-3">
      <div class="d-flex">
        <div><strong>{{ statusLabel }}</strong></div>
        <div class="ml-auto text-body-2 grey--text">
          {{ formatCurrency(item.amount_cents) }}
        </div>
      </div>

      <div class="d-flex text-body-2 grey--text">
        <div class="limit-195">{{ item.description }}</div>
        <div class="ml-auto">
          {{ formatDate(item.history_time) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatters from '@/lib/formatters'
export default {
  name: 'DisputeHistoryItem',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    statusLabel() {
      if (this.item.dispute_status == 'new_dispute')
        return 'Dispute Pending'

      return 'Dispute Denied'
    },

    iconColor() {
      switch(this.item.dispute_status) {
        case 'new_dispute':
          return '#F97575'
        default:
          return '#C5C5C5'
      }
    },
  },

  methods: {
    ...formatters,

  },
}
</script>

<style scoped>
  .limit-195 {
    max-width: 195px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>